// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6197) return "static/chunks/6197-ab7231e907960d47.js";
	if (chunkId === 5308) return "static/chunks/5308-192ba2cb415837df.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"960":"42f54a721b6f39e0","7512":"6f6d6e88d5813eb0","9651":"9be695e992890e60"}[chunkId] + ".js";
};